// extracted by mini-css-extract-plugin
export default {"wrapper":"debugInfo__wrapper__R9SgL"};